<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="flex flex-wrap items-end">
                <div class="flex-grow">
                    <vs-button v-if="isPermissionAdd()" @click="addPosition" color="primary" icon-pack="feather"
                               icon="icon-plus">
                        Thêm chức vụ
                    </vs-button>
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh" ref="agGridTable"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="permisionsList"
                         :animateRows="true"
                         :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                         paginationPageSize="20"
                         :pagination="true"
                         @pagination-changed="onPaginationChanged"
                         @grid-ready="onGridReady"
                         :autoSizeStrategy="autoSizeStrategy"
                         tooltipShowDelay="0"
                         tooltipHideDelay="5000">
            </ag-grid-vue>

            <div class="vx-row" v-if="totalElements > 0">
                <div class="vx-col w-full flex">
                    <div style="min-width:200px">
                        <span class="content-page font-bold">Hiển thị: </span><span class="text-page">{{
                            countElementPage
                            > totalElements ? totalElements : countElementPage
                        }} / {{ totalElements }} </span>
                    </div>
                    <vs-pagination :total="totalPages" @change="loadPage"
                                   v-model="currentPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Pagination from "../../ui-elements/Pagination.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererContent from "./cell-renderer/CellRendererContent";
import {isRouter} from "../../../store/permission";
import {constRouter} from "../../../store/constant";

export default {
    components: {
        AgGridVue,

        // Cell Renderer
        Pagination,
        CellRendererActions,
        CellRendererContent
    },
    data() {
        return {
            countElementPage: 0,
            totalElements: 0,
            searchQuery: "",
            maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'ID',
                    field: 'id',
                    width: 30
                },
                {
                    headerName: 'Tên chức vụ',
                    field: 'name',
                    width: 100
                },
                {
                    headerName: 'Mô tả',
                    field: 'description',
                    width: 300
                },
                {
                    headerName: 'Hành động',
                    field: 'actions',
                    width: 80,
                    cellRenderer: 'CellRendererActions',
                },

            ],
            permisionsList: [],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            totalPages: 0,
            currentPage: 1,
        }
    },
    created() {
        this.initScreen();
    },
    watch: {
        '$store.state.deleteNotification'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('DELETE_NOTIFY', false);
            }
        },
    },
    methods: {
        isPermissionAdd() {
            return isRouter(this, constRouter.positinon_add)
        },
        addPosition() {
            this.$router.push('/user/add-position').catch(() => {
            })
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },
        initScreen() {
            this.$vs.loading();
            this.$oauth.get('/position/find-all').then((response) => {
                this.$vs.loading.close();
                this.permisionsList = response.data;
                this.countElementPage = this.currentPage * 20;
                this.totalElements = this.permisionsList.length;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger',
                });
            });
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },
        loadPage: function (currentPage) {
            if (this.gridApi) this.gridApi.paginationGoToPage(currentPage - 1)
        },
    },
}
</script>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
